import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const exportToExcel = async (
  sheet1,        // SUMMARY DATA
  sheet1_name,   // "Summary"
  sheet2,        // SUPPORT TICKETS
  sheet2_name,   // "Support Tickets"
  excel_name
) => {
  const workbook = new ExcelJS.Workbook();

  /* =====================================================
     SHEET 1 : SUPPORT TICKETS
     ===================================================== */
  const ticketSheet = workbook.addWorksheet(sheet2_name || "Support Tickets");

  // Heading
  ticketSheet.mergeCells("A1:I1");
  ticketSheet.getCell("A1").value = `Support Tickets - Report generated on: ${new Date().toLocaleString()}`;
  ticketSheet.getCell("A1").font = { bold: true, size: 12 };
  ticketSheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
  ticketSheet.getRow(1).height = 20;

  // Headers
  const ticketHeaders = [
    "Ticket Id", "Ticket Type", "Module", "Title", "Client",
    "Status", "Priority", "Hours", "Assigned To", "Created Date", "Updated Date"
  ];

  ticketHeaders.forEach((h, i) => {
    const cell = ticketSheet.getCell(2, i + 1);
    cell.value = h;
    cell.font = { bold: true };
    cell.alignment = { wrapText: true, vertical: "middle" };
  });

  // Data rows
  let tRow = 3;
  sheet2.forEach(r => {
    ticketSheet.getCell(`A${tRow}`).value = Number(r.ticket_master_id);
    ticketSheet.getCell(`B${tRow}`).value = r.issue_type;
    ticketSheet.getCell(`C${tRow}`).value = r.module_name;
    ticketSheet.getCell(`D${tRow}`).value = r.title;
    ticketSheet.getCell(`E${tRow}`).value = r.short_code;
    ticketSheet.getCell(`F${tRow}`).value = r.status;
    ticketSheet.getCell(`G${tRow}`).value = r.priority;

    // Hours as number
    ticketSheet.getCell(`H${tRow}`).value = Number(r.enhancement_hours || 0);

    ticketSheet.getCell(`I${tRow}`).value = r.assigned_to;

    // Date as Excel date
    ticketSheet.getCell(`J${tRow}`).value = new Date(r.created_date);
    ticketSheet.getCell(`J${tRow}`).numFmt = "dd-mm-yyyy hh:mm:ss AM/PM";

    ticketSheet.getCell(`K${tRow}`).value = new Date(r.updated_date);
    ticketSheet.getCell(`K${tRow}`).numFmt = "dd-mm-yyyy hh:mm:ss AM/PM";

    ticketSheet.getRow(tRow).height = 28;
    tRow++;
  });

  // Column widths
  [10, 15, 25, 35, 15, 20, 10, 10, 20, 23, 23].forEach((w, i) => {
    ticketSheet.getColumn(i + 1).width = w;
  });


  /* =====================================================
   SHEET 2 : SUMMARY
   ===================================================== */
  const summarySheet = workbook.addWorksheet(sheet1_name || "Summary");

  // 1️⃣ Get headers from first row object
  const summaryHeaders = Object.keys(sheet1[0]);

  // 2️⃣ Write header row
  summaryHeaders.forEach((h, colIndex) => {
    const cell = summarySheet.getCell(1, colIndex + 1);
    cell.value = h;
    cell.font = { bold: true };
    cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
  });

  // 3️⃣ Write data rows
  let startRow = 2;

  sheet1.forEach((rowObj, rowIndex) => {
    summaryHeaders.forEach((header, colIndex) => {
      summarySheet
        .getCell(startRow + rowIndex, colIndex + 1)
        .value = rowObj[header];
    });
  });

  // 4️⃣ Column widths
  summaryHeaders.forEach((header, i) => {
    summarySheet.getColumn(i + 1).width = Math.max(header.length, 8);
  });

  // 5️⃣ Freeze header row (nice UX)
  summarySheet.views = [{ state: "frozen", ySplit: 1 }];


  /* =====================================================
     EXPORT
     ===================================================== */
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), excel_name);
};
